import { render, staticRenderFns } from "./header-search.vue?vue&type=template&id=c5f9d006&scoped=true&"
import script from "./header-search.vue?vue&type=script&lang=js&"
export * from "./header-search.vue?vue&type=script&lang=js&"
import style0 from "./header-search.vue?vue&type=style&index=0&id=c5f9d006&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5f9d006",
  null
  
)

export default component.exports